export default __webpack_public_path__ + "static/media/cebu-north.ac4b9410.jpg";